import React, { useMemo, useRef } from 'react';
import { observer } from 'mobx-react';
import { useServices } from '../../react-hooks/use-services.hook';
import { TitanJackpotWidgetConfiguration } from '../../services/configurations/config-data-sections/titan-jackpot-widget.configuration';
import { LottiePlayer } from '../lottie-player/lottie-player.component';
import { AnimationItem } from 'lottie-web';

const ENTER_FRAME_EVENT_NAME = 'enterFrame';

const ANIMATION_PAUSE_INTERVAL = 3000;

const MINOR_JACKPOT_FRAME = 10;
const MAJOR_JACKPOT_FRAME = 90;
const MEGA_JACKPOT_FRAME = 180;

const ANIMATION_FRAME_STOPS = [MINOR_JACKPOT_FRAME, MAJOR_JACKPOT_FRAME, MEGA_JACKPOT_FRAME];

interface ITitanAnimationComponentProps {
    widgetConfig: TitanJackpotWidgetConfiguration;
}

export const TitanJackpotAnimationComponent: React.FC<ITitanAnimationComponentProps> = observer((props) => {
    let lottie = useRef<AnimationItem>(null);
    let animationCounter = 0;

    const services = useServices();

    const styles = useMemo(() => ({ borderRadius: 10, display: 'grid' }), []);

    const updateAnimationCounter = (): void => {
        animationCounter++;
    }

    const getTitanJackpotIndex = (): number => {
        return animationCounter % props.widgetConfig?.jackpotIds.length;
    }

    const getCurrentJackpotId = (): string => {
        const index: number = getTitanJackpotIndex();

        return String(props.widgetConfig.jackpotIds[index]);
    }

    const setLottieInstance = (instance: AnimationItem): void => {
        if (lottie.current) {
            lottie.current.removeEventListener(ENTER_FRAME_EVENT_NAME, handleEnterFrame);
        }

        if (!instance) {
            return;
        }

        lottie.current = instance;
        lottie.current.addEventListener(ENTER_FRAME_EVENT_NAME, handleEnterFrame);
    };

    const handleEnterFrame = (e): void => {
        if (Math.round(lottie.current.currentFrame) === ANIMATION_FRAME_STOPS[getTitanJackpotIndex()]) {
            lottie.current.pause();

            services.titanJackpot.updateJackpotHandler(getCurrentJackpotId());

            setTimeout(() => {
                lottie.current.play();
            }, ANIMATION_PAUSE_INTERVAL);

            updateAnimationCounter();
        }
    }

    return (
        <LottiePlayer
            src={services.theme.currentTheme.images.lottieAnimation.titanJackpot.toString()}
            lottieRef={setLottieInstance}
            keepLastFrame
            autoplay
            loop
            style={styles}
        />
    )
});
